// extracted by mini-css-extract-plugin
export default {"container":"Regression_container__L655G","dropzone":"Regression_dropzone__jKWdT","disabled":"Regression_disabled__9HBWw"};